module.exports = __webpack_public_path__ + "static/img/user-pick-bg.9263812.jpg";